import { useEffect } from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
function getScrollLeft(rootNode, contentNode, scrollToIndex, scrollToMiddle) {
    var scrollToChild = contentNode.children[scrollToIndex];
    var firstChild = contentNode.children[0];
    if (!scrollToChild || !firstChild) {
        return null;
    }
    var scrollToChildRect = scrollToChild.getBoundingClientRect();
    var rootRect = rootNode.getBoundingClientRect();
    if (scrollToMiddle) {
        return (contentNode.scrollLeft +
            scrollToChild.offsetLeft -
            (contentNode.offsetWidth - scrollToChild.offsetWidth) / 2);
    }
    // is child to scroll to already visible
    var isVisible = scrollToChildRect.left >= rootRect.left &&
        scrollToChildRect.right <= rootRect.right;
    if (isVisible) {
        return null;
    }
    return scrollToChild.offsetLeft - firstChild.offsetLeft;
}
/** Handle scrolling to a particular item */
export function useSliderScrollToIndex(contentRef, rootRef, scrollToIndex, smoothInitialScroll) {
    var scrollToMiddle = useFlag('dyw2');
    useEffect(function () {
        requestAnimationFrame(function () {
            var _a, _b;
            var contentNode = contentRef.current;
            var rootNode = rootRef.current;
            if (!contentNode || !rootNode) {
                return;
            }
            // if scrollToIndex value is not valid - get the last item index
            var actualScrollToIndex = Math.max(Math.min(scrollToIndex !== null && scrollToIndex !== void 0 ? scrollToIndex : 0, ((_b = (_a = contentNode === null || contentNode === void 0 ? void 0 : contentNode.children) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) - 1), 0);
            var currentScrollLeft = contentNode.scrollLeft;
            var scrollLeft = getScrollLeft(rootNode, contentNode, actualScrollToIndex, scrollToMiddle);
            if (scrollLeft !== currentScrollLeft && scrollLeft !== null) {
                if (smoothInitialScroll) {
                    contentNode.scrollLeft = scrollLeft;
                }
                else {
                    // scrollTo with a behavior parameter doesn't
                    // behave if the behavior is set in CSS...
                    contentNode.style.scrollBehavior = 'auto';
                    contentNode.scrollLeft = scrollLeft;
                    contentNode.style.scrollBehavior = 'smooth';
                }
            }
        });
    }, [contentRef, rootRef, scrollToIndex, smoothInitialScroll, scrollToMiddle]);
}
//# sourceMappingURL=useSliderScrollToIndex.js.map